import React, { useEffect, useState, lazy, Suspense } from "react";
import LayoutDumpster from "../components/layout-dumpster";
import Container from "../components/layout/container";
import Content from "../components/content/Content";
import Box from "../components/content/Box";
import OndeffModal from "../components/OndeffModal";
import ViewDumpsterPricesForm from "../components/viewDumpsterPricesForm";
import BookingPageComponent from "../components/content/BookingPageComponent";
import Stars from "../components/stars";
import CustomerLandingPage from "../components/content/CustomerLandingPage";
import { trackBookingSubmission } from "../helpers/helpers";

const OnlineBooking = lazy(() => import('@hometown/react-hometown-lib').then((module) => ({default: module.OnlineBooking})));


const BOOKPAGE = (props) => {
    const env = props.pageContext.env;
    const code = props.pageContext.code;
    const proReviews = props.pageContext.reviews;
    // const apolloService = "http://localhost:4000/api/v1"
    const apolloService = `${process.env.GATSBY_BOOKABLE_SERVICE_API}`;
    const googlePlaceAutocompleteApiKey = `${process.env.GATSBY_BOOKABLE_API_AUTOCOMPLETE}`;
    const gatsbyKey = props.pageContext.gatsbyKey;
    const [bookingInitialData, setBookingInitialData] = useState();
    const [showBooking, setShowBooking] = useState(false)
    const [isBack, setIsBack] = useState(false);
    const [profile, setProfile] = useState();
    const [openAvailabilityForm, setOpenAvailabilityForm] = useState(false);
    const [initialFormData, setInitialFormData] = useState([]);
    const [hasAddress, setHasAddress] = useState();
    const [isVisible, setIsVisible] = useState(false);
    const [reviews, setReviews] = useState([])
    let foundAddress;

    const getAvailabilityParam = () => {
        if (typeof window !== "undefined") {
            const params = new Proxy(new URLSearchParams(window.location.search), {
                get: (searchParams, prop) => searchParams.get(prop),
            });
            if(params.av) {
                foundAddress = true;
                return params.av;
            }
            return;
        }
    }
    const [obtainedBookingId, setObtainedBookingId] = useState(getAvailabilityParam());
    const [boxClass, setBoxClass] = useState('');

    const seo =
    {
        url: `book`,
        env: env,
        code: code,
        page: 'book',
        title: "Book a Dumpster | Hometown Dumpster Rental",
        description: "Compare dumpster prices and rental terms from top dumpster services.  Book a roll-off dumpster online.",
        canonical_tag: `${process.env.GATSBY_SITE_DOMAIN}/book`
    }

    const formatData = (data) => {
        let address = data.find(element => element.key === 'fullFormData').value
        if(address) {
            address = JSON.parse(address)
            let addressObj = {}
            address.forEach(e => addressObj[e[0]] = e[1])
            const wasteType = data.find(element => element.key === 'wasteType').value
            const dumpsterSize = data.find(e => e.key === 'dumpsterSize')?.value
            const obj = {
                "odf_country": addressObj.country,
                "odf_locality": addressObj.locality,
                "odf_place_id": addressObj.place_id,
                "odf_postal_code": addressObj.postal_code,
                "odf_state": addressObj.state,
                "odf_street": addressObj.street,
                "odf_street2": addressObj.street2,
                "wasteType": wasteType,
            }
            if (dumpsterSize) {
                obj.dumpsterSize = dumpsterSize;
            }
            return obj;
        }
    }
    let defaultTemplateName;
    let defaultServiceId;

    const formatDefaultData = () => {
        let localData;
        let sessionData;
        let queryParams
        if(typeof window !== 'undefined'){ 
            localData = JSON.parse(localStorage.getItem('onlineBookingData'));
            sessionData = JSON.parse(sessionStorage.getItem('service-detail'));
            queryParams = window.location.search
        }
        if (sessionData?.templateName && sessionData?.serviceId) {
            defaultTemplateName = sessionData.templateName;
            defaultServiceId = sessionData.serviceId
        }
        if(localData){
            if(localData.finalDataForBooking) {
                const data = localData.finalDataForBooking
                const formattedData = formatData(data);
                if(formattedData.odf_postal_code) {
                    foundAddress = true;
                }
                return formattedData;
            }else {
                const initialDataValues = localData.initialValues?.find(data => data.key === 'fullFormData')?.value;
                if(initialDataValues.odf_postal_code) {
                    foundAddress = true;
                }
                return initialDataValues
            }
        }
        else{
            if(queryParams?.includes('a') && queryParams?.includes('w')) {
                foundAddress = true;
            }
            return { "wasteType": "1" }
        }
    }

    const [formSubmitData, setFormSubmitData] = useState(formatDefaultData());

    const [templateName, setTemplateName] = useState(defaultTemplateName ? defaultTemplateName : (!getAvailabilityParam() ? 'multiple-card-list' : 'card-list'));
    const [serviceId, setServiceId] = useState(defaultServiceId);

    const getDumpsterSizeValue = (size) => {
        switch (size) {
            case 'small':
                return '1'
            case 'medium':
                return '2'
            case 'large':
                return '3'
            default:
                return '4'
        }
    }

    const serviceSeekerCallback = (data) => {
        const addresAndWaste = formatData(data);
        let variables = { ...addresAndWaste }
        data?.forEach(element => {
            if(element.key === 'deliveryAddress' || element.key === 'fullFormData'){
                delete variables[element.key]   
            }
            else {
                variables[element.key] = element.value
            }
        })
        if(variables.template){
            setTemplateName(variables.template);
            if(variables.service?.id) {
                setServiceId(variables.service.id);
            }
        } else {
            setTemplateName(!obtainedBookingId ? 'multiple-card-list' : 'card-list');
            setServiceId();
        }
        if(variables.profileData){
            setProfile({ ...variables.profileData, proId: +variables.profileData._attributes_id });
        }
        if (!variables.service) {
            let initialFormVariables = []
            for (let key in variables) {
                switch (key) {
                    case 'service':
                        initialFormVariables.push({
                            key: 'service_id',
                            value: variables[key].id
                        })
                        break;
                    case 'profileData':
                        if (variables[key]) {
                            initialFormVariables.push({
                                key: 'pro_id',
                                value: +variables[key]._attributes_id
                            })
                        }
                        break;
                    case 'dumpsterSize':
                        if (variables[key]) {
                            const values = variables[key].split(',')
                            if (values?.length === 1) {
                                initialFormVariables.push({
                                    key: 'dumpsterSize',
                                    value: getDumpsterSizeValue(values[0])
                                })
                            }
                        }
                        break;
                    case 'wasteType':
                        if (variables[key] && Array.isArray(variables[key])) {
                            initialFormVariables.push({
                                key: 'wasteType',
                                value: variables[key][0]
                            })
                        }
                        break;
                    default:
                        initialFormVariables.push({
                            key,
                            value: variables[key]
                        })
                        break;

                }
            }
            setInitialFormData([...initialFormVariables])
            setOpenAvailabilityForm(true);
        } else {
            setFormSubmitData(addresAndWaste);
            setBookingInitialData(data)
            setShowBooking(!showBooking);
        }
    }

    const handleBackOnlineBooking = (data) => {
        formatData(data);
        setProfile();
        setShowBooking(!showBooking);
        setIsBack(true);
    }

    const formatPhoneNumber = (phoneNumberString) => {
        var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
        var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
    
        if(match) return '(' + match[1] + ') ' + match[2] + '-' + match[3]
    
        return ''
    }

    const handleCallback = () => {
        setOpenAvailabilityForm(false);
        setInitialFormData([])
    }

    const handleSubmit = (values) => {
        setFormSubmitData(values)
        setHasAddress(true);
    }

    const getRandomItems = (array, count) => {
        const shuffled = [...array].sort(() => Math.random() - 0.5);
        return shuffled.slice(0, count);
    }

    useEffect(() => {
        if(!obtainedBookingId) {
            setBoxClass('book-padding')
        }
        setHasAddress(foundAddress ? foundAddress : false);
        const randomReviews = getRandomItems(proReviews, 6);
        setReviews(randomReviews);
    }, [])

    const dumpsterReviews = () => {
        function truncateString (str) {
            if (str.length <= 600) return str;
            return str.slice(0, 600) + '...';
        }

        function getDate (date) {
            const newDate = date?.replace(" ", "T").replace(/T(\d):/, "T0$1:");;
            if (newDate) {
                return new Date(newDate).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric"
                });
            }
            return '';
        }

        return (
            <div className="booking-reviews-container">
                {
                    reviews?.map((review, index) => {
                        return (
                            <div key={index} className="book-review">
                                <div className="book-review-header">
                                    <Stars rate={review.stars} page='profile'/>
                                    <div className="date">{getDate(review.date)}</div>
                                </div>
                                
                                <div className="book-review-title">{review.customer}{(review.place === '' ? '' : ` in ${review.place}`)}</div>
                                <p>{truncateString(review.text)}</p>
                            </div>
                        )
                    })
                }
            </div>
        )
    }

    return (
        <LayoutDumpster seo={seo} env={env} code={code} hidden={true}>
            <div className="book-page" id="book-page">
                {!showBooking && 
                <Container id="service-seeker-container" classes={"book-container"}>
                    <Content width="col-12">
                        <Box classes={boxClass}>
                        {obtainedBookingId ?
                        <>
                            <CustomerLandingPage 
                                apolloURL={apolloService}
                                availabilityReqId={obtainedBookingId}
                                gatsbyKey={gatsbyKey}
                                serviceCardCallback={serviceSeekerCallback}
                                defaultTemplateName={templateName ? templateName : 'card-list'}
                                defaultService={serviceId}
                                setIsVisible={setIsVisible}
                            />
                            {isVisible && reviews?.length > 0 &&
                            <div className="book-form" style={{ marginTop: '30px' }}>
                                <h3 className="book-form-title">Hear From Recent Customers</h3>
                                <h4 className="book-form-subtitle">Verified reviews of local dumpster companies</h4>
                                <div className="booking-reviews">
                                    { dumpsterReviews() }
                                </div>
                            </div>
                            }
                        </>
                        : hasAddress ? (
                        formSubmitData &&
                        <>
                            <BookingPageComponent
                                formSubmitData={formSubmitData}
                                googlePlaceAutocompleteApiKey={googlePlaceAutocompleteApiKey}
                                serviceSeekerCallback={serviceSeekerCallback}
                                isBack={isBack}
                                gatsbyKey={gatsbyKey}
                                templateName={templateName}
                                serviceId={serviceId}
                                callBy='book'
                                limitPerPage={+process.env.GATSBY_DUMPSTERS_LIMIT}
                                setIsVisible={setIsVisible}
                            />
                            {isVisible && reviews?.length > 0 &&
                            <div className="book-form" style={{ marginTop: '30px' }}>
                                <h3 className="book-form-title">Hear From Recent Customers</h3>
                                <h4 className="book-form-subtitle">Verified reviews of local dumpster companies</h4>
                                <div className="booking-reviews">
                                    { dumpsterReviews() }
                                </div>
                            </div>
                            }
                        </>
                        ) : hasAddress === false &&
                        <div id="service-seeker" className="book-form">
                            <h3 className="book-form-title">Compare and Book Local Dumpster Rental Services</h3>
                            <h4 className="book-form-subtitle">3000+ dumpster services, transparent pricing, and reviews from real customers</h4>
                            <ViewDumpsterPricesForm 
                                btnLabel="View dumpster prices"
                                onSubmit={handleSubmit}
                                id="view-dumpster-prices-form-booking"
                            />
                            {reviews?.length > 0 &&
                            <>
                                <hr className="book-divider-line"/>
                                <div className="booking-reviews">
                                    <h3 className="book-form-title">Hear From Recent Customers</h3>
                                    <h4 className="book-form-subtitle">Verified reviews of local dumpster companies</h4>
                                    { dumpsterReviews() }
                                    <div className="button-wrapper">
                                        <button class='view-dumpster-prices' onClick={() => window.scrollTo(0, 0)}>View dumpsters in your area</button>
                                    </div>
                                </div>
                            </>
                            }
                        </div>
                        }
                        {openAvailabilityForm &&
                            <OndeffModal
                                startVisible={true}
                                proid={profile?.proId}
                                class="get-a-quote get-a-quote-profile-page"
                                ondeffCode='priceAndAvailabilityForm'
                                initialFormData={initialFormData}
                                handleCallback={handleCallback}
                            />
                        }
                        </Box>
                    </Content>
                </Container>
                }
                {showBooking && (
                <Container>
                    <Content width="col-12">
                        <Box classes='order-container'>
                            <div id="online-booking" className="online-booking">
                                <Suspense fallback={<h1>Loading…</h1>}>
                                    <OnlineBooking
                                        handleBack={handleBackOnlineBooking}
                                        proId={profile.proId} 
                                        proName={profile.n}
                                        apolloURL={apolloService}
                                        stripeApiKey={`${process.env.GATSBY_STRIPE_API_KEY}`}
                                        googlePlaceAutocompleteApiKey={googlePlaceAutocompleteApiKey}
                                        initialData={bookingInitialData} 
                                        proPhone={profile.ph ? formatPhoneNumber(profile.ph) : ""} 
                                        backUrl={`/${profile.ur}`}
                                        gatsbyKey={gatsbyKey}
                                        label='Boton' 
                                        size='lg'
                                        availabilityRequestId={obtainedBookingId}
                                        staticUrl={`${process.env.GATSBY_SITE_DOMAIN}/assets/`}
                                        // staticUrl='https://hometownstaticsites.z19.web.core.windows.net/assets/'
                                        maxDatePicker={process.env.MAX_DATE_PICKER}
                                        // maxDatePicker={7776000000}
                                        trackBookingSubmission={trackBookingSubmission}
                                    />
                                </Suspense>
                            </div>
                        </Box>
                    </Content>
                </Container>)}
            </div>
        </LayoutDumpster>
    )
}

export default BOOKPAGE;